import React from 'react';
import HeroSection from './components/HeroSection';
import FeaturedServices from './components/FeaturedServices';
import FeaturedSection from './components/FeaturedSection';
import ChooseUs from './components/ChooseUs';
import FAQ from './components/FAQ';

const Home = () => {
    return (
        <>
            <HeroSection />
            <div id='choose-us'>
                <ChooseUs />
            </div>
            <div id="services">
                <FeaturedServices />
            </div>
            <div id='project-overflow'>
                <FAQ />
            </div>
            <FeaturedSection />
        </>
    );
}

export default Home;
